export const languageCode = {
  computed: {
    languageCode() {
      return this.$store.state.language_code
    },
  },
}
export const setLanguageCode = {
  methods: {
    setLanguageCode(value) {
      this.$store.commit('setLanguageCode', value)
    }
  },
}
export const detectLanguageCode = {
  mixins: [
    setLanguageCode,
  ],
  methods: {
    detectLanguageCode() {
      return this.setLanguageCode('en')
    },
  },
}
